import LocalizedStrings from 'react-localization';
import english from '../lang/en';
import espanish from '../lang/esp';

export const strings = new LocalizedStrings({
  en: english,
  esp: espanish,
});
